<template>
  <div id="confirm-order-page-cont" v-if="showOrder">
    <div
      class="content"
      :class="{
        'h5-confirm-order': isH5,
        'confirm-order': !isH5,
        'pad-app-h5-confirm-order': isMGAppInPad && isH5,
      }"
    >
      <div class="order-top-wrap">
        <!-- 用户信息 -->
        <div class="user-info" v-show="user">
          <img
            class="avatar"
            :src="user.avatar + '?imageView2/0/w/100'"
            alt="头像"
          />
          <div class="info-wrap">
            <p class="name">{{ user.nickname }}</p>
            <p class="mobile">{{ user.mobile | filterTel }}</p>
          </div>
        </div>
        <!-- 商品信息 -->
        <div class="course-list">
          <div
            v-for="item in sub_order_list"
            :key="item.course_id"
            class="course-card"
          >
            <img
              class="cover"
              :src="
                handleImageUrl(item.goods_cover_url) + '?imageView2/0/w/300'
              "
              alt=""
            />
            <div class="course-info">
              <p class="course-title">
                {{ item.goods_title }}
              </p>
              <div class="other-info">
                <div class="price-wrap">
                  <!-- 实付金额 -->
                  <!-- 促销-但使用了优惠券 -->
                  <p
                    v-if="orderInfo.activity_type === 2 && couponInfo.coupon_id"
                    class="real-price"
                  >
                    <span>￥</span>{{ payableAmount }}
                  </p>
                  <p v-else class="real-price">
                    <span>￥</span>{{ item.real_price / 100 }}
                  </p>
                  <p
                    v-if="item.total_price !== item.real_price"
                    class="origin-price"
                  >
                    ￥{{ item.total_price / 100 }}
                  </p>
                </div>
                <!-- 有效期 -->
                <p class="validity-period">
                  有效期：<span v-if="item.validity_type === 2">
                    <span v-if="item.enrollment_days"
                      >随到随学{{ item.enrollment_days }}天</span
                    >
                    <span v-else
                      >{{
                        moment(item.course_start_time * 1000).format(
                          "YYYY.MM.DD HH:mm"
                        )
                      }}至{{
                        moment(item.course_end_time * 1000).format(
                          "YYYY.MM.DD HH:mm"
                        )
                      }}</span
                    >
                  </span>
                  <span v-else-if="item.validity_type === 3">永久有效</span>
                  <span v-else-if="item.validity_type === 1"
                    >至{{
                      moment(item.course_end_time * 1000).format(
                        "YYYY.MM.DD HH:mm:ss"
                      )
                    }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="order-bottom-wrap">
        <ul class="order-info">
          <li class="order-total-price">
            <span class="module-title">课程总价</span>
            <p>
              <span class="normal-text"
                >共{{ sub_order_list.length }}个课程
              </span>
              <span class="order-origin-price">
                ¥{{ orderInfo.total_price / 100 }}</span
              >
            </p>
          </li>
          <!-- 联报|拼团 -->
          <li v-if="[3, 4].includes(orderInfo.activity_type)">
            <span class="module-title">促销活动</span>
            <p>
              <span v-if="orderInfo.activity_type === 3" class="normal-text"
                >课程联报，</span
              >
              <span v-if="orderInfo.activity_type === 4" class="normal-text"
                >拼团活动，</span
              >
              <span class="order-discount-price">-¥{{ discountPrice }}</span>
            </p>
          </li>
          <li v-if="showCoupon">
            <span class="module-title">优惠券抵扣</span>
            <p @click="openCouponDialog" style="cursor: pointer">
              <span v-if="!couponInfo.coupon_id" class="normal-text">{{
                orderInfo.activity_type === 3 ? "无优惠券可用" : "选择优惠券"
              }}</span>
              <span
                class="order-discount-price"
                v-else-if="couponInfo.coupon_type === 1"
                >-￥{{ couponInfo.amount / 100 }}</span
              >
              <span class="order-discount-price" v-else
                >{{ couponInfo.ratio / 10 }}折优惠</span
              >
              <i class="el-icon-arrow-right arrow-icon"></i>
            </p>
          </li>
          <li>
            <span class="module-title">应付金额</span>
            <p class="order-real-price">￥{{ payableAmount }}</p>
          </li>
          <li>
            <span class="module-title">备注</span>
            <p
              @click="openNotesDialog"
              class="normal-text remark-text"
              style="cursor: pointer"
            >
              <span>{{ remark ? remark : "请填写备注" }}</span
              ><i class="el-icon-arrow-right arrow-icon"></i>
            </p>
          </li>
        </ul>
      </div>

      <!-- 协议 -->
      <p v-if="!isH5" class="protocol-wrap">
        <el-checkbox v-model="checked"> </el-checkbox
        >点击支付按钮即表示您已阅读并同意
        <a href="javascript:;" @click="jumpPage('/service-agreement')"
          >《服务协议》</a
        >
      </p>

      <div class="fixed-bottom">
        <!-- 协议 -->
        <p v-if="isH5" class="protocol-wrap">
          <el-checkbox v-model="checked"> </el-checkbox
          >点击支付按钮即表示您已阅读并同意
          <a href="javascript:;" @click="jumpPage('/service-agreement')"
            >《服务协议》</a
          >
        </p>
        <div class="btn-wrap">
          <button
            class="buy-btn"
            :class="{
              'is-disabled': buyBtnLoading,
            }"
            @click="apiCreateOrder"
            :disabled="buyBtnLoading"
            v-preventReClick
            v-html="buyBtnText"
          ></button>
        </div>
      </div>
    </div>
    <coupon-dialog ref="couponDialog" @selectCoupon="selectCoupon" />
    <notes-dialog ref="notesDialog" @submit="handleSubmit" />
  </div>
</template>

<script>
import NotesDialog from "./NotesDialog";
import CouponDialog from "@saas/pages/src/confirm-order/components/CouponDialog";
import { isH5, handleImageUrl, isMGAppInPad } from "@saas/components/src";
import moment from "moment";
import {
  getCourseInfo,
  createOrder,
} from "@saas/server-api/src/product-details";
export default {
  data: function () {
    return {
      showOrder: false,
      buyBtnLoading: false,
      handleImageUrl,
      moment,
      checked: true,
      orderInfo: {}, //==========
      couponInfo: {},
      isH5: isH5(),
      // million,
      sub_order_list: [], //课程信息=========
      goodsIds: [], //课程id
      loading: false,
      calPriceData: {}, //
      user: {},
      isMGAppInPad: false,
      remark: "", //备注
    };
  },
  mounted() {
    this.isMGAppInPad = isMGAppInPad();
  },
  methods: {
    handleSubmit(text) {
      this.remark = text;
    },
    openNotesDialog() {
      this.$refs?.notesDialog?.openDialog(this.remark);
    },
    apiCreateOrder() {
      if (!this.checked) {
        this.$message.warning("请先阅读并同意服务协议");
        return false;
      }
      // 创建订单
      if (this.buyBtnLoading) return;
      this.buyBtnLoading = true;
      let { goods_items, activity_type } = this.calPriceData;
      let params = {};
      if (activity_type === 3) {
        // 联报
        params = {
          goods_items: goods_items,
        };
      } else {
        params = {
          goods_id: goods_items[0].goods_id,
          coupon_id: this.couponInfo.coupon_id, //是否使用优惠券
        };
        // if (activity_type === 1 && goods_items[0].activity_id) {
        //   params.coupon_id = goods_items[0].activity_id;
        // } else
        if (activity_type === 2 && !params.coupon_id) {
          // 促销+未使用优惠券
          params.promotion_id = goods_items[0].activity_id;
        } else if (activity_type === 4) {
          // 拼团
          params.goods_items = goods_items;
        }
      }
      //线索渠道参数
      let { course_id, lesson_id } = this.$route.query;
      if (course_id) {
        params.param_map = {
          course_id,
          lesson_id,
        };
      }
      // 备注
      params.remark = this.remark;
      createOrder(params)
        .then((res) => {
          if (res.code === 1) {
            if (res.data) {
              this.payOrder(res.data);
            }
          } else if (res.code === 55004 && res.data?.cannot_goods_ids?.length) {
            let cannotGoodsIds = res.data.cannot_goods_ids;
            let courseNames = [];
            this.jointInfo.class_groups.forEach((group) => {
              group.course_list.forEach((course) => {
                if (cannotGoodsIds.includes(course.goods_id)) {
                  courseNames.push(course.course_name);
                }
              });
            });
            this.$message.warning(
              `课程 ${courseNames.join("、")} 已单独下单，无法联报下单`
            );
          } else {
            this.$message.error(res.message);
          }
          this.buyBtnLoading = false;
        })
        .catch(() => {
          this.buyBtnLoading = false;
        });
    },
    jumpPage(url) {
      if (window.isElectron || this.isH5) {
        this.$router.push(url);
      } else {
        this.$router.push(url);
      }
    },
    selectCoupon(info) {
      this.couponInfo = { ...info };
      console.log(this.couponInfo);
    },
    openCouponDialog() {
      if (this.orderInfo.activity_type === 3) return false;
      this.$refs.couponDialog.openDialog(this.sub_order_list[0].course_id);
    },
    handleLessonNum(data) {
      let lessonNum = 0;
      if (data.unit_list && data.unit_list.length) {
        data.unit_list.forEach((unit) => {
          if (unit.lesson_list && unit.lesson_list.length) {
            lessonNum += unit.lesson_list.length;
          }
        });
      }
      data.lessonNum = lessonNum;
      return data;
    },
    async payOrder(order_no) {
      // if (this.checked) {
      // 是否使用优惠券
      // if (this.couponInfo.coupon_id) {
      //   let params = {
      //     coupon_id: this.couponInfo.coupon_id,
      //     order_no: order_no,
      //   };
      //   let { code, message } = await calPrice(params);
      //   if (code !== 1) {
      //     this.$message.error(message);
      //     return;
      //   }
      // }
      let url = `/payment/${order_no}`;
      if (this.$route.name === "ConfirmOrder") {
        this.$router.replace(url);
      } else {
        this.$router.push(url);
      }
      // } else {
      //   this.$message.warning("请先阅读并同意服务协议");
      // }
    },
  },
  filters: {
    //加密手机号
    filterTel(val) {
      if (val) {
        return val.substring(3, 0) + "****" + val.substring(7);
      }
    },
  },
  computed: {
    showCoupon() {
      // 团购、联报-隐藏
      return ![3, 4].includes(this.orderInfo.activity_type);
    },
    discountPrice() {
      let { total_price, real_price } = this.orderInfo;
      return (total_price - real_price) / 100;
    },
    payableAmount() {
      let price = this.orderInfo.real_price / 100;
      if (this.couponInfo.coupon_id) {
        // 有优惠券
        let beforePrice = this.orderInfo.real_price;
        if (this.orderInfo.activity_type === 2) {
          // 促销
          beforePrice = this.orderInfo.total_price;
        }
        if (this.couponInfo.coupon_type === 1) {
          price = ((beforePrice - this.couponInfo.amount) / 100).toFixed(2);
        } else {
          price = ((beforePrice * (this.couponInfo.ratio / 100)) / 100).toFixed(
            2
          );
        }
      }
      return price;
    },
    buyBtnText() {
      return `立即支付 <span>￥</span><span class="price">${this.payableAmount}</span>`;
    },
  },
  components: {
    "coupon-dialog": CouponDialog,
    NotesDialog,
  },
  watch: {
    calPriceData: {
      handler: function (newVal) {
        if (newVal) {
          let {
            original_price,
            real_price,
            goods_list = [],
            activity_type,
          } = newVal;
          this.orderInfo = {
            total_price: original_price,
            real_price,
            activity_type,
          };
          this.sub_order_list = goods_list.map((item) => {
            return {
              ...item,
              total_price: item.price,
              real_price: item.real_price,
            };
          });
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.pad-app-h5-confirm-order {
  width: 375px !important;
  margin: 0 auto;
  .fixed-bottom {
    width: 375px !important;
  }
}
.confirm-order {
  max-width: 800px;
  width: 100%;
  min-height: 100vh;
  padding-top: 30px;
  padding-bottom: 200px;
  .unpaid-order-tips {
    text-align: center;
    font-weight: 500;
    font-size: 18px;
    color: $saas-text-color;
    margin-bottom: 30px;
  }
  .order-top-wrap {
    border-radius: 24px 24px 0 0;
    background: #fff;
    padding: 16px 16px 0 16px;
    margin-bottom: 10px;
    // 用户信息
    .user-info {
      display: flex;
      padding: 16px;
      height: 83px;
      background: #fafafa;
      border-radius: 24px;
      margin-bottom: 24px;
      .avatar {
        width: 50px;
        height: 50px;
        border-radius: 16px;
        border: 1px solid #e2e2e2;
        margin-right: 12px;
        object-fit: cover;
      }
      .info-wrap {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .name {
        font-weight: 500;
        font-size: 18px;
        color: #000000;
        line-height: 25px;
      }
      .mobile {
        font-size: 14px;
        color: #515350;
        line-height: 20px;
      }
    }
    // 商品信息
    .course-card {
      &:last-child {
        border-bottom: none;
        padding-bottom: 24px;
      }
      display: flex;
      padding-bottom: 12px;
      border-bottom: 1px solid #efefef;
      .cover {
        width: 140px;
        height: 78px;
        border-radius: 5px;
        margin-right: 12px;
        object-fit: cover;
      }
      .course-info {
        flex: 1;
        width: 0;
      }
      .course-title {
        width: 100%;
        font-weight: 500;
        font-size: 18px;
        color: $saas-text-color;
        line-height: 25px;
        padding-top: 4px;
        padding-bottom: 16px;
        word-break: break-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .other-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .price-wrap {
        display: flex;
        align-items: center;
      }
      .real-price {
        font-weight: 600;
        font-size: 20px;
        color: #f03349;
        line-height: 28px;
        span {
          font-size: 12px;
        }
        margin-right: 12px;
      }
      .origin-price {
        font-size: 16px;
        color: #747573;
        line-height: 22px;
        text-decoration: line-through;
      }
      .validity-period {
        font-size: 14px;
        color: #747573;
        line-height: 20px;
      }
    }
  }

  .order-bottom-wrap {
    padding: 0 20px 10px;
    margin-bottom: 10px;
    background: #fff;
    .order-info {
      li {
        display: flex;
        justify-content: space-between;
        padding: 15px 0;
      }
      .module-title {
        font-size: 16px;
        color: #515350;
        line-height: 22px;
      }
      .normal-text {
        font-size: 16px;
        color: $saas-text-color;
        line-height: 22px;
      }
      .remark-text {
        display: flex;
      }
      .remark-text span {
        max-width: 500px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .order-origin-price {
        font-weight: 600;
        font-size: 16px;
        color: $saas-text-color;
        line-height: 22px;
      }
      .arrow-icon {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
      }
      .order-discount-price {
        font-weight: 600;
        font-size: 16px;
        color: #f03349;
        line-height: 22px;
      }
      .order-real-price {
        font-weight: 600;
        font-size: 16px;
        color: #f03349;
        line-height: 22px;
      }
      .order-total-price {
        padding: 25px 0;
        margin-bottom: 9px;
        border-bottom: 1px solid #efefef;
      }
    }
  }
  .protocol-wrap {
    background: #fff;
    padding: 20px 20px 24px;
    border-radius: 0 0 24px 24px;
    font-size: 16px;
    color: #515350;
    line-height: 22px;
    ::v-deep .el-checkbox .el-checkbox__inner {
      position: relative;
      top: -1px;
      border-radius: 3px;
      margin-right: 5px;
      border-color: #e8e8e9;
    }
    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-color: #fff;
    }
    a {
      margin-left: 8px;
      font-size: 16px;
      color: #00c89d;
      line-height: 22px;
    }
  }
  .fixed-bottom {
    z-index: 2;
    padding: 25px 20px;
    position: fixed;
    bottom: 0;
    width: 800px;
    height: 100px;
    background: #ffffff;
    box-shadow: 0px -6px 16px 0px rgba(102, 116, 107, 0.1);
    border-radius: 24px 24px 0px 0px;
    .buy-btn {
      width: 760px;
      height: 50px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 12px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 22px;
    }
    .reorder-again {
      width: 350px;
      height: 50px;
      background: #f2f3f5;
      border-radius: 12px;
      font-weight: 400;
      font-size: 16px;
      color: $saas-text-color;
      line-height: 22px;
    }
    .btn-wrap {
      display: flex;
      justify-content: space-between;
    }
  }
}

.h5-confirm-order {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 4rem;
  padding-top: 0.33rem;
  background: #fff;
  .unpaid-order-tips {
    font-weight: 500;
    font-size: 0.37rem;
    color: $saas-text-color;
    line-height: 0.53rem;
    margin-bottom: 0.33rem;
    text-align: center;
  }
  .order-top-wrap {
    position: relative;
    &::after {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      content: "";
      width: 100vw;
      height: 0.13rem;
      background: $saas-bg-color;
    }
    padding: 0 0.32rem 0.5rem;
    // 用户信息
    .user-info {
      display: flex;
      padding: 0.21rem 0.29rem;
      height: 1.49rem;
      background: #fafafa;
      border-radius: 0.32rem;
      margin-bottom: 0.4rem;
      .avatar {
        width: 1.07rem;
        height: 1.07rem;
        border-radius: 0.21rem;
        border: 0.03rem solid #e2e2e2;
        margin-right: 0.21rem;
        object-fit: cover;
      }
      .info-wrap {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .name {
        font-weight: 500;
        font-size: 0.43rem;
        color: #000000;
        line-height: 0.6rem;
      }
      .mobile {
        font-weight: 400;
        font-size: 0.32rem;
        color: #515350;
        line-height: 0.44rem;
      }
    }
    // 商品信息
    .course-card {
      &:last-child {
        padding-bottom: 0;
      }
      display: flex;
      padding-bottom: 0.4rem;
      .cover {
        width: 3.74rem;
        height: 2.08rem;
        border-radius: 0.13rem;
        margin-right: 0.2rem;
        object-fit: cover;
      }
      .course-info {
        flex: 1;
        width: 0;
        display: flex;
        flex-direction: column;
      }
      .course-title {
        width: 100%;
        font-weight: 500;
        font-size: 0.43rem;
        color: $saas-text-color;
        line-height: 0.6rem;
        padding-bottom: 0.13rem;
        word-break: break-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .other-info {
        flex: 1;
        display: flex;
        flex-direction: column-reverse;
        justify-content: space-between;
      }
      .price-wrap {
        display: flex;
        align-items: center;
      }
      .real-price {
        font-weight: 600;
        font-size: 0.45rem;
        color: #f03349;
        line-height: 0.64rem;
        span {
          font-size: 0.32rem;
        }
        margin-right: 0.27rem;
      }
      .origin-price {
        font-size: 0.32rem;
        color: #747573;
        line-height: 0.59rem;
        text-decoration: line-through;
      }
      .validity-period {
        font-size: 0.29rem;
        color: #747573;
        line-height: 0.4rem;
      }
    }
  }

  .order-bottom-wrap {
    padding: 0 0.4rem 0.4rem;
    .order-info {
      li {
        display: flex;
        justify-content: space-between;
        padding: 0.26rem 0;
      }
      .pd-top-0 {
        padding-top: 0;
      }
      .module-title {
        font-size: 0.4rem;
        color: #515350;
        line-height: 0.56rem;
      }
      .normal-text {
        font-size: 0.4rem;
        color: $saas-text-color;
        line-height: 0.56rem;
      }
      .remark-text {
        display: flex;
        max-width: 70%;
        span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          flex: 1;
        }
      }
      .order-origin-price {
        font-weight: 600;
        font-size: 0.4rem;
        color: $saas-text-color;
        line-height: 0.56rem;
      }
      .arrow-icon {
        font-weight: 600;
        font-size: 0.34rem;
        line-height: 0.56rem;
      }
      .order-discount-price {
        font-weight: 600;
        font-size: 0.4rem;
        color: #f03349;
        line-height: 0.56rem;
      }
      .order-real-price {
        font-weight: 600;
        font-size: 0.4rem;
        color: #f03349;
        line-height: 0.56rem;
      }
      .order-total-price {
        padding: 0.4rem 0;
        margin-bottom: 0.14rem;
        border-bottom: 0.01rem solid #efefef;
      }
    }
  }
  .fixed-bottom {
    z-index: 2;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 2.8rem;
    box-shadow: 0rem -0.16rem 0.43rem 0rem rgba(102, 116, 107, 0.1);
    border-radius: 0.64rem 0.64rem 0rem 0rem;
    padding: 0 0.32rem 0.53rem;
    background: #fff;
    .protocol-wrap {
      padding: 0.27rem 0 0.27rem 0.13rem;
      font-size: 0.29rem;
      color: #515350;
      line-height: 0.4rem;
      ::v-deep .el-checkbox .el-checkbox__inner {
        border-radius: 0.08rem;
        margin-right: 0.13rem;
        border-color: #e8e8e9;
      }
      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-color: #fff;
      }
      a {
        margin-left: 0.07rem;
        font-size: 0.29rem;
        color: #00c89d;
        line-height: 0.4rem;
      }
    }
    .buy-btn {
      width: 9.36rem;
      height: 1.33rem;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 0.32rem;
      font-weight: 500;
      font-size: 0.43rem;
      color: #ffffff;
      line-height: 0.6rem;
    }

    .reorder-again {
      width: 4.4rem;
      height: 1.33rem;
      background: #f2f3f5;
      border-radius: 0.32rem;
      font-weight: 500;
      font-size: 0.43rem;
      color: $saas-text-color;
      line-height: 0.6rem;
    }
    .btn-wrap {
      display: flex;
      justify-content: space-between;
    }
  }
}

// button 禁用样式
.buy-btn.is-disabled:disabled {
  cursor: not-allowed; /* 更改鼠标指针为禁止符号 */
  opacity: 0.5; /* 降低不透明度以给予视觉提示 */
  pointer-events: none; /* 阻止点击事件 */
}
</style>
